import Vue from 'vue';
import Vuex from 'vuex';

window.Pusher = require('pusher-js');

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        user: false,
        users: [],
        settings: false,
        notifications: [],
        message_number: 0,
        suporte_token: false,
        suporte_user: false,
        app_suporte_url: '',
        app_suporte_email: '',
        app_suporte_password: '',
        municipio: '',
    },
    mutations: {
        login(state, response) {

            localStorage.setItem('token', response.access_token);
            localStorage.setItem("changeUnidade", false);

            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.access_token;
            axios.post('/api/auth/user').then((response) => {
                state.user = response.data.user;
            });

        },

        logout(state) {
            axios.post('api/auth/logout');
            delete window.axios.defaults.headers.common.Authorization;
            localStorage.removeItem('token');
            localStorage.removeItem('token_suporte');
            state.message_number = 0;
            state.user = false;
        },

        setSettings(state, data) {
            state.settings = data;
        },
        pushSettings(state, data) {
            state.settings = {
                ...state.settings,
                ...data
            };
        },
        setUser(state) {
            if (localStorage.getItem('token')) {
                axios.post('/api/auth/user').then(function (response) {
                    state.user = response.data.user;
                    state.settings = response.data.settings;
                    // state.users.push(response.data.user);
                    let meta = document.querySelector('[name="user"]');
                    meta.setAttribute('content', state.user.id);
                }).finally(() => {
                    let token = document.head.querySelector('meta[name="csrf-token"]');
                    if (token) {
                        window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
                    }

                    // window.Echo = new Echo({
                    //     broadcaster: "pusher",
                    //     key: state.settings.pusher_key,
                    //     cluster: state.settings.pusher_app_cluster,
                    //     encrypted: true,
                    //     authEndpoint: "/api/broadcasting/auth",
                    //     auth: {
                    //         headers: {
                    //             Authorization: "Bearer " + localStorage.getItem("token"),
                    //             Accept: "application/json",
                    //             "X-CSRF-Token": token,
                    //         },
                    //     },
                    // });
                });


            }
        },
        setSettingSuporte(state) {
            axios.get("api/dashboard/settings").then((response) => {
                response.data.data.forEach((obj) => {
                    if (obj.key == "app_suporte_url") {
                        state.app_suporte_url = obj.value;
                    }
                    if (obj.key == "app_suporte_email") {
                        state.app_suporte_email = obj.value;
                    }
                    if (obj.key == "app_suporte_password") {
                        state.app_suporte_password = obj.value;
                    }
                });
            });

        },
        LOAD_NOTIFICATIONS(state, data) {
            state.notifications = data
        },
        ADD_NOTIFICATION(state, notification) {
            state.notifications.unshift(notification)
        },
        LOAD_MESSAGE_NUMBER(state, data) {
            state.message_number = data
        },
        ADD_MESSAGE_NUMBER(state) {
            state.message_number = state.message_number + 1
        },
        UPDATE_MESSAGE_NUMBER(state,number) {
            state.message_number = state.message_number - number
        },
        MARK_AS_READ(state, id) {
            let index = state.notifications.filter(notification => notification.id == id)
            state.notifications.splice(index, 1)
        },
        MARK_ALL_AS_READ(state) {
            state.notifications = []
        },
        LOAD_USERS(state, users) {
            state.users = users
        },

        JOINING_USER(state, user) {
            state.users.push(user)
        },

        LEAVING_USER(state, user) {
            state.users = state.users.filter(u => {
                return u.id !== user.id
            })
        },
        loginSuporte(state, response) {
            if (localStorage.getItem('token_suporte')) {
                state.suporte_token = localStorage.getItem('token_suporte');
                state.suporte_user = response;
            } else {
                localStorage.setItem('token_suporte', response.token);
                state.suporte_token = response.token;
                state.suporte_user = response.user;
            }
        },
        settingSuport(state, response) {
            state.app_suporte_url = response.app_suporte_url;
            state.app_suporte_email = response.app_suporte_email;
            state.app_suporte_password = response.app_suporte_password;
        },
        setMunicipio(state, municipio) {
            state.municipio = municipio;
        }

    },
    actions: {
        loadNots(context) {
            axios
                .get("api/notifications")
                .then(response => {
                    context.commit('LOAD_NOTIFICATIONS', response.data
                    )
                });
        },
        loadChats(context) {
            axios
            .get("api/dashboard/getUnread")
            .then(response => {
                context.commit('LOAD_MESSAGE_NUMBER', response.data);
                // console.log('store.js',response.data);
            })
            .catch(error => {
                console.error(error);
            });

        },
        async setLoginSuporte(context) {

            var url_app_suporte = "";

            if (window.config.app_suporte_url) {
                url_app_suporte = window.config.app_suporte_url + "api/auth/user";

            } else {
                url_app_suporte = context.state.settings.app_suporte_url + "api/auth/user";
            }

            await axios
                .get(url_app_suporte, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token_suporte"),
                    },
                })
                .then((response) => {
                    context.commit("loginSuporte", response.data);
                })
                .catch((error) => {
                    this.$snack.success({
                        button: false,
                        text: error.response.data,
                    });
                });

        },
        setSettingSuporte(context) {
            axios.get("api/dashboard/suportes/settings").then((response) => {
                var dados = {};
                response.data.data.forEach((obj) => {
                    if (obj.key == "app_suporte_url") {
                        dados.app_suporte_url = obj.value;
                    }
                    if (obj.key == "app_suporte_email") {
                        dados.app_suporte_email = obj.value;
                    }
                    if (obj.key == "app_suporte_password") {
                        dados.app_suporte_password = obj.value;
                    }
                });

                context.commit('settingSuport', dados);
            });

        },
        markAsRead(context, params) {
            axios.post('api/dashboard/admin/notification/read', params)
                .then(() => context.commit('MARK_AS_READ', params.id))
        },
        markAllAsRead(context) {
            axios.post('api/dashboard/admin/notification/allread')
                .then(() => context.commit('MARK_ALL_AS_READ'))
        },
        getMunicipio(context) {
            axios.get('api/municipio').then((response) => {
                console.log('Banco de dados do município:', response.data.municipio);
                context.commit('setMunicipio', response.data.municipio);
            }).catch((error) => {
                console.error('Erro ao obter o município:', error);
            });
        }
    }, getters: {
        getUsersLength: state => state.users.length


    }
});

export default store;

